import { Component } from '@theme/component';

/**
 * Share row of the product page.
 *
 * Facebook, X and Pinterest are plain links. Copy puts the page address on the clipboard.
 *
 * @extends {Component<{ status: HTMLElement }>}
 */
class OudhShare extends Component {
  /** Copies the link and says so. */
  async copy() {
    await this.#copyUrl('Link copied');
  }

  /**
   * @param {string} message
   */
  async #copyUrl(message) {
    const url = this.dataset.url ?? window.location.href;

    try {
      await navigator.clipboard.writeText(url);
    } catch {
      // Clipboard is blocked outside secure contexts; fall back to a selection copy.
      const field = document.createElement('textarea');
      field.value = url;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.append(field);
      field.select();
      document.execCommand('copy');
      field.remove();
    }

    const { status } = this.refs;
    status.textContent = message;
    window.setTimeout(() => {
      status.textContent = '';
    }, 2500);
  }
}

if (!customElements.get('oudh-share')) {
  customElements.define('oudh-share', OudhShare);
}
